import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import { Book, DonutLarge } from '@material-ui/icons';

import { PROGRESS_INFO } from '../../constants/general';

import i18n from '../../i18n';

import '../../assets/stylesheets/DashboardView.css';

class DashboardMenu extends Component {
  render() {
    const { onMenuItemClick } = this.props;
    return (
      <Paper className="blockContainer">
        <h5>{i18n.t('dashboard:dashboardMenu')}</h5>
        <List component="nav" aria-label={i18n.t('schedule:sideMenu')}>
          <ListItem
            id='bookingInfoButton'
            button
            onClick={() => onMenuItemClick(PROGRESS_INFO.BOOKING)}
          >
            <ListItemIcon>
              <Book color="secondary" />
            </ListItemIcon>
            <ListItemText primary={i18n.t('dashboard:bookingInfo')} />
          </ListItem>
          <ListItem
            id='studioInfoButton'
            button
            onClick={() => onMenuItemClick(PROGRESS_INFO.STUDIO)}
          >
            <ListItemIcon>
              <DonutLarge color="secondary" />
            </ListItemIcon>
            <ListItemText primary={i18n.t('dashboard:studioProgressInfo')} />
          </ListItem>
          <ListItem
            id='setInfoButton'
            button
            onClick={() => onMenuItemClick(PROGRESS_INFO.SET)}
          >
            <ListItemIcon>
              <DonutLarge color="secondary" />
            </ListItemIcon>
            <ListItemText primary={i18n.t('dashboard:setProgressInfo')} />
          </ListItem>
        </List>
      </Paper>
    );
  }
}

DashboardMenu.propTypes = {
  onMenuItemClick: PropTypes.func.isRequired
};

export default DashboardMenu;
